import {BEGELEIDER} from '~/plugins/constants';

export default ({store, redirect}) => {
  const user = store.state.auth.user;
  if (user && user.role_id === BEGELEIDER && !user.has_subscription) {
    return redirect('/abonnementen');
  }
};
